module.exports = __webpack_public_path__ + "img/HealerIcon.14a0633c.png";